module.exports = __webpack_public_path__ + "f59f1dbd7e6dcd7cc9426372247a5a96.svg";